import {Component, ViewChild} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";
import {EmeaContractModel, emeaContractModelFactory} from "../../emea-contract/emea-contract.model";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {EmeaContractService} from "../../emea-contract/emea-contract.service";
import {SuccessComponent} from "../../errors/success.component";
import {toggleLoading} from "../../misc/loading.decorator";
import {handleErrors} from "../../misc/handle-errors.decorator";

@Component({
  templateUrl: "./create-emea-contract.template.pug",
  providers: [
    EmeaContractService,
  ],
})

export class CreateEmeaContractComponent extends WorkflowStep {
  error: Error;
  contract: EmeaContractModel = emeaContractModelFactory();

  @ViewChild("success")
  successComponent: SuccessComponent;

  @toggleLoading()
  @handleErrors()
  async loadData() {
    this.contract = await this.emeaContractService.getFormData(this.workflowService.workflowConfig.projectId);
  }

  ready() {
    this.loadData();
  }

  upload() {
    this.loading = true;

    this.emeaContractService.uploadFormData(this.contract, this.workflowService.workflowConfig.projectId)
      .then(
        (result) => {
          this.successComponent.showSuccessMessage(result.message);
          return this.loadData();
        },
        (error) => {
          this.loading = false;
          console.error(error);
          this.error = error;
          window.scrollTo(0, 0);
        },
      );
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private emeaContractService: EmeaContractService,
  ) {
    super(true);
  }
}
